import { PromptConfigViewsEnum } from "../../../../../utils/enums";
import { TabsContainer } from "./TabsContainer.styled";
import { Tabs } from "@ann/web-components";

const TabsContainerComponent = () => {
  return (
    <TabsContainer>
      <Tabs.List>
        <Tabs.Tab size="small" index={PromptConfigViewsEnum.CREATE} >
          Create
        </Tabs.Tab>
        <Tabs.Tab size="small" index={PromptConfigViewsEnum.CONFIG} >
          Configuration
        </Tabs.Tab>
      </Tabs.List>
    </TabsContainer>
  );
};

export default TabsContainerComponent;